import React, { useState } from "react"
import Logo from "src/images/logo-alt.svg"
import Button from "src/components/Button"
import FooterSection from './FooterSection'
import FixedCta from './FixedCta'

const Footer = ({ settings }) => {

  const navData = settings.content.footer_navigation.map((item) => {
    return {
      ...item,
      open: false
    }
  })

  const [data, setData] = useState(navData)

  const handleClick = (_uid) => {
    setData(
      data =>
        data.map((item) => {
          return {
            ...item,
            open: _uid === item._uid ? !item.open : false
          }
        })
    )
  }

  return (
    <footer className="bg-blue-700 bg-cover bg-no-repeat bg-center" style={{backgroundImage: "url(/Shape.svg)"}}>
      <div className="flex flex-wrap max-w-7xl mx-auto py-12 lg:py-24 overflow-hidden">
        <div className="w-full lg:w-5/12 px-6">
          <Logo className="mb-8" />
          <p className="text-white text-xs lg:text-sm font-body max-w-sm mb-4">
            Be the first to hear about new product launches, industry
            news, case studies and exclusive event invitations.
          </p>
          <Button className="mb-10 bg-red hover:bg-darkred" target={`/newsletter/`}>Sign up to the newsletter</Button>
          <p className="text-white text-xs lg:text-sm font-body w-3/4 lg:max-w-xs mb-4">
            Prince of Wales Works, Armytage Road,
            Brighouse, West Yorkshire HD6 1QF
          </p>
          <ul className="flex flex-row space-x-4 mb-4">
            <li className="font-body text-white text-xs lg:text-sm hover:text-red transition duration-300"><a href="mailto:enquiries@yps.co.uk"><span className="text-red">E:</span> enquiries@yps.co.uk</a></li>
            <li className="bg-white w-px h-4 block"></li>
            <li className="font-body text-white text-xs lg:text-sm hover:text-red transition duration-300"><a href="tel:01484 715111"><span className="text-red">T:</span> 01484 715111</a></li>
          </ul>
          <ul className="flex flex-row space-x-4">
            <li><a className="text-white transition duration-300 hover:text-red" href="https://www.facebook.com/YorkshirePackagingSystems" target="_blank" rel="noreferrer"><i className="fab fa-facebook fa-lg"></i><span className="hidden">Facebook</span></a></li>
            <li><a className="text-white transition duration-300 hover:text-red" href="https://twitter.com/shrink_wrapping" target="_blank" rel="noreferrer"><i className="fab fa-twitter fa-lg"></i><span className="hidden">Twitter</span></a></li>
            <li><a className="text-white transition duration-300 hover:text-red" href="https://www.youtube.com/user/lsealer" target="_blank" rel="noreferrer"><i className="fab fa-youtube fa-lg"></i><span className="hidden">Youtube</span></a></li>
            <li><a className="text-white transition duration-300 hover:text-red" href="https://www.linkedin.com/company/yorkshire-packaging-systems-ltd" target="_blank" rel="noreferrer"><i className="fab fa-linkedin fa-lg"></i><span className="hidden">LinkedIn</span></a></li>
          </ul>
        </div>
        <div className="w-full lg:w-7/12 flex flex-col lg:flex-row flex-wrap">
          <div className="w-full flex flex-col lg:flex-row flex-wrap my-6 lg:my-0 ml-auto pr-4">
            {data.map((item, index) => (
              <div className="ml-auto lg:w-auto w-full" key={index}>
                <FooterSection {...item} onClick={handleClick} />
              </div>
            ))}
          </div>
          <div className="w-full">
            <ul className="flex flex-row flex-wrap justify-end">
              {
                settings.content.footer_logos.map((image, index) => {
                  return (
                    <li className="flex flex-col justify-center px-4" key={index}>
                      <img className="mx-auto my-4" src={image.filename} alt={image.alt} />
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-blue-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-wrap flex-col lg:flex-row max-w-7xl mx-auto py-6 text-white text-xxs font-body tracking-wider">
              <p className="mb-2 lg:mb-0">&copy; 2022 Yorkshire Packaging Systems</p>
              <p className="lg:ml-auto">Website by <a className="font-bold hover:text-red transition duration-300" href="https://www.thebiggerboat.co.uk">The Bigger Boat</a></p>
            </div>
          </div>
      </div>
      <FixedCta />
    </footer>
  )
}

export default Footer
